<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef" @finish="tableFinish" :page-size="320" :page-list="[320, 640, 1600, 3200]" hide-setting>
      <template slot="searchBar">
        <el-form-item label="厂商">
          <company-select v-model="tableData.search.company_id" clearable @change="companyChange"/>
        </el-form-item>
        <el-form-item label="MAC批次">
          <mac-batch-select v-model="tableData.search.mac_company_id" clearable :company-id="tableData.search.company_id" :key="tableData.search.company_id"/>
        </el-form-item>
        <el-form-item label="MAC地址">
          <el-input v-model="tableData.search.mac" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button v-if="showJump && checkApi('getMacPool')" type="primary" size="small" plain @click="getJumpPage">跳转到最后使用</el-button>
        <div class="tips">
          <span v-for="item in macSuffixType" :key="item.id" :style="`background-color: ${item.backgroundColor};color: ${item.id === 0 ? '#000' : '#fff'}`">{{item.msg}}</span>
        </div>
      </template>
    </vue-table>
  </div>
</template>

<script>
  import {macSuffixType} from "@utils/formatList"
  import CompanySelect from "@view/components/select/CompanySelect"
  import MacBatchSelect from "@view/components/select/MacBatchSelect"
  export default {
    name: "macPool",
    components: {CompanySelect,MacBatchSelect},
    data() {
      return {
        macSuffixType,
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "厂商", property: "company", width: 100, position: "center", tooltip: true},
            {label: "MAC批次", property: "prefix", width: 120, position: "center"},
            {label: "0", property: "0", format: macSuffixType, position: "center"},
            {label: "1", property: "1", format: macSuffixType, position: "center"},
            {label: "2", property: "2", format: macSuffixType, position: "center"},
            {label: "3", property: "3", format: macSuffixType, position: "center"},
            {label: "4", property: "4", format: macSuffixType, position: "center"},
            {label: "5", property: "5", format: macSuffixType, position: "center"},
            {label: "6", property: "6", format: macSuffixType, position: "center"},
            {label: "7", property: "7", format: macSuffixType, position: "center"},
            {label: "8", property: "8", format: macSuffixType, position: "center"},
            {label: "9", property: "9", format: macSuffixType, position: "center"},
            {label: "A", property: "A", format: macSuffixType, position: "center"},
            {label: "B", property: "B", format: macSuffixType, position: "center"},
            {label: "C", property: "C", format: macSuffixType, position: "center"},
            {label: "D", property: "D", format: macSuffixType, position: "center"},
            {label: "E", property: "E", format: macSuffixType, position: "center"},
            {label: "F", property: "F", format: macSuffixType, position: "center"},
          ],
          api: "getMacPool",
          search: {
            company_id: "",
            mac_company_id: "",
            mac: "",
          },
        },
        surplusList: [],
        searchCommit: {}
      }
    },
    computed: {
      showJump() {
        return this.searchCommit.company_id && this.searchCommit.mac_company_id;
      },
      maxPage() {
        const tableRef = this.$refs["tableRef"];
        if (!tableRef) return false;
        let {total, pageSize} = tableRef.pagingData;
        let page = parseInt(total / pageSize + '');
        if (total % pageSize !== 0 || total === 0) {
          page++
        }
        return page;
      }
    },
    methods: {
      async getJumpPage() {
        const nv = {
          ...this.searchCommit,
          mode: "offset"
        }
        const res = await this.$Http.getMacPool(nv);
        if (res?.data) {
          const {position} = res.data;
          const pagingData = this.$refs["tableRef"].pagingData;
          pagingData.currentPage = Math.ceil(position / pagingData.pageSize) || 1;
          this.getTableList();
        }
      },
      companyChange() {
        this.tableData.search.mac_company_id = "";
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
      tableFinish(data, search) {
        this.searchCommit = search;
        let list = data.list || [];
        this.tableData.tableList = [];
        const page = this.$refs["tableRef"].pagingData.currentPage
        for (let i = 0; i < list.length;) {
          let count = 0;
          let obj = {prefix: list[i].mac.slice(0, 16), company: list[i].company?.name};
          for (let j = 0; j < 16; j++ ) {
            let mac = list[i + j]?.mac || "";
            if (mac.indexOf(obj.prefix) !== -1) {
              obj[mac.slice(-1)] = list[i + j]?.type;
              count++;
            } else {
              break;
            }
          }
          let isExist = this.surplusList.find(item => item.prefix === obj.prefix);
          isExist && Object.assign(obj, isExist);
          if (Object.keys(obj).length < 17) {
            if (page === 1 && i === 0) { //显示首页第一条
              this.tableData.tableList.push(obj);
            } else if (page === this.maxPage && i !== 0) { //显示尾页最后一条
              this.tableData.tableList.push(obj);
            } else {
              !isExist && this.surplusList.push(obj)
            }
          } else {
            this.tableData.tableList.push(obj);
          }
          i += count;
        }
      },
    },
  }
</script>

<style scoped lang="scss">
/deep/ {
  .tips {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    
    & > span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 72px;
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
      text-align: center;
      border: none;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 500;
      color: #1e293b;
      box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
      transition: all 0.2s ease;
    }
  }
  .el-table {
    .el-table__body {
      td {
        padding: 0;
        .cell {
          line-height: 28px;
          padding: 0;
        }
      }
    }
  }
}
</style>
